<template>
  <AtomHorizontalScroll>
    <div class="breadcrumbs">
      <NuxtLink :to="{ name: 'leagues' }">{{ $t('shared.nav.leagues') }}</NuxtLink>
      <NuxtLink :to="{ name: 'leagues-league', params: { league: league.slug }}">{{ league.name }}</NuxtLink>
      <NuxtLink to="#" v-if="!['leagues-league', 'leagues-league-game'].includes(route.name)">{{ heading }}</NuxtLink>
      
      <!-- Game Center Breadcrumbs -->
      <NuxtLink :to="{ name: 'leagues-league-fixtures', params: { league: league.slug }}" v-if="isGame && !isGameFinished">
        {{ $t('shared.nav.fixtures') }}
      </NuxtLink>
      <NuxtLink :to="{ name: 'leagues-league-results', params: { league: league.slug }}" v-if="isGame && isGameFinished">
        {{ $t('shared.nav.results') }}
      </NuxtLink>
      <NuxtLink to="#" v-if="isGame">
        {{ game?.name }}
      </NuxtLink>
    </div>
  </AtomHorizontalScroll>
</template>

<script setup>
const { t } = useI18n()
const route = useRoute()
const league = useLeagueStore()
const gameSlug = computed(() => route.params?.game)
const game = computed(() => useState(`game:${gameSlug.value}`).value)

const isGame = computed(() => route.name === 'leagues-league-game' && game.value?.name)
const isGameFinished = computed(() => game.value?.status === 'finished')

const headingKeyMap = {
  'leagues-league-fixtures': 'shared.nav.fixtures',
  'leagues-league-teams': 'shared.nav.teams',
  'leagues-league-results': 'shared.nav.results',
  'leagues-league-table': 'shared.nav.table',
  'leagues-league-statistics': 'shared.nav.statistics',
}

const heading = computed(() => {
  const key = headingKeyMap[route.name]
  return key ? t(key, { league: league.name }) : ''
})
</script>
